/**
 * 在所有组件中都执行一下 devTest 方法，主要用于表单数据自动填充，可以搭配 https://fakerjs.dev/ 共同使用
 *
 */

const devTestMixin = {
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.devTest()
    }
  },
  methods: {
    devTest() {},
  },
}

export default devTestMixin



// WEBPACK FOOTER //
// ./src/mixins/devTestMixin.js